/*
 * @Author: your name
 * @Date: 2022-03-08 21:27:34
 * @LastEditTime: 2022-03-09 00:57:09
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /private-claim/src/utils/auth.js
 */
import cookie from "js-cookie";
import { aggregationModule } from "../api";

class Auth {
  constructor(router = {}) {
    this.router = router;
    this.appId = "wxa80091d5bf174477";
    this.authUrl = "https://open.weixin.qq.com/connect/oauth2/authorize";
    this.authHash = "wechat_redirect";
    this.query = {
      response_type: "code",
      scope: "snsapi_userinfo",
    };

    this.tokenKey = "token";
    this.openIDKey = "openid";

    this.subscription();

    this.count = 0;
  }

  //   http://test.gchealth.top/?code=071Wn2Ga1qyQLC02TKGa12qJr81Wn2GJ&state=&code=001ED4ll2hv3M8484Col2atdpC2ED4lR&state=&code=041oZE0w3t9t6Y2Scb0w3idqKc3oZE0k&state=&code=021wT60w3ig17Y2Ayl1w3mfBT31wT60s&state=&code=021i6J000gR9rN1Psw000C1o200i6J0G&state=#/

  get token() {
    return cookie.get(this.tokenKey);
  }

  set token(value) {
    return cookie.set(this.tokenKey, value, { expires: 30 });
  }

  set openId(value) {
    return cookie.set(this.openIDKey, value, { expires: 30 });
  }

  // 判断是否登陆
  isLogin() {
    return !!this.token;
  }

  // 监听
  subscription() {
    if (!this.router.beforeEach) return;

    this.router.beforeEach(async (to, form, next) => {
      const code = this._getQuery("code");

      // 有授权
      if (code) {
        const { data } = await aggregationModule.auth.getToken(code);

        this.token = data.token;
        this.openId = data.openid;

        // 为了兼容hash模式
        const originalLink = this._getOriginalLink();

        window.location.href = originalLink;

        return false;
      }

      if (!this.isLogin()) {
        return this.toLogin();
      }

      next();
    });
  }

  // 登陆授权
  toLogin() {
    const redirectUrl = this._mergeQuery({
      appId: this.appId,
      redirect_uri: encodeURIComponent(window.location.href),
    });

    window.location.href = redirectUrl;

    return false;
  }

  // 合并授权参数
  _mergeQuery(params = {}) {
    const data = { ...params, ...this.query };

    const authHref = Object.keys(data).reduce(
      (url, key, index) => `${url}${index ? "&" : "?"}${key}=${data[key]}`,
      this.authUrl
    );

    return `${authHref}#${this.authHash}`;
  }

  _getQuery(key) {
    const queryArr = window.location.href.match(/([^?=&]+)(=([^&]*))/g);

    if (!Array.isArray(queryArr)) return "";

    const query = queryArr.reduce(
      (a, v) => (
        (a[v.slice(0, v.indexOf("="))] = v.slice(v.indexOf("=") + 1)), a
      ),
      {}
    );

    return query[key];
  }

  _getOriginalLink() {
    return window.location.href.replace(/\?(.)+(?=#)/, "");
  }
}

export default Auth;
